export enum BankAccountType {
  checking = 'checking',
  savings = 'savings',
  businessChecking = 'businessChecking',
}

export interface BankAccountDetails {
  /** The type of bank account used for the eCheck.Net transaction */
  accountType: BankAccountType;

  /** The masked bank account number */
  accountNumber: string;

  /** Name of the person who holds the bank account */
  nameOnAccount: string;

  /** The name of the bank */
  bankName: string;
}
